class AuthService {
  constructor() {
    this.baseURL = '/api/admin/v1/';
    this.userKey = 'auth_user';
  }

  // 獲取儲存的用戶資料
  getUser() {
    const user = localStorage.getItem(this.userKey);
    return user ? JSON.parse(user) : null;
  }

  // 儲存用戶資料
  setUser(user) {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  // 清除認證資料
  clearAuth() {
    localStorage.removeItem(this.userKey);
  }

  // 獲取請求headers
  getAuthHeaders() {
    return {
      'Content-Type': 'application/json'
    };
  }

  // 登入
  async login(email, password) {
    try {
      const response = await fetch(`${this.baseURL}login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include', // Important: send and receive cookies
        body: JSON.stringify({ email, password })
      });

      const result = await response.json();

      if (result.success && result.data) {
        // Token is stored in HTTP-only cookie by server
        this.setUser(result.data.user);
        return { success: true, user: result.data.user, message: result.message };
      } 
        return { success: false, message: result.message };
      
    } catch {
      return { success: false, message: 'authentication_failed' };
    }
  }

  // 登出
  async logout() {
    try {
      await fetch(`${this.baseURL}logout`, {
        method: 'DELETE',
        headers: this.getAuthHeaders(),
        credentials: 'include' // Important: send cookies
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      this.clearAuth();
    }
  }

  // 檢查認證狀態
  async checkAuth() {
    try {
      const response = await fetch(`${this.baseURL}me`, {
        headers: this.getAuthHeaders(),
        credentials: 'include' // Important: send cookies
      });

      if (response.ok) {
        const result = await response.json();
        if (result.success && result.data && result.data.authenticated) {
          this.setUser(result.data.user);
          return { authenticated: true, user: result.data.user };
        }
      }

      // Token無效，清除本地資料
      this.clearAuth();
      return { authenticated: false, user: null };
    } catch {
      this.clearAuth();
      return { authenticated: false, user: null };
    }
  }

  // TOTP 驗證（登入第二步）
  async verifyTotp(pendingToken, code) {
    try {
      const response = await fetch('/api/user/v1/verify_totp', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pending_token: pendingToken, code })
      });
      return response.json();
    } catch {
      return { success: false, message: 'authentication_failed' };
    }
  }

  // TOTP Management API
  async totpSetup() {
    const response = await fetch('/api/user/v1/totp/setup', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    });
    return response.json();
  }

  async totpEnable(code) {
    const response = await fetch('/api/user/v1/totp/enable', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code })
    });
    return response.json();
  }

  async totpDisable(password) {
    const response = await fetch('/api/user/v1/totp/disable', {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password })
    });
    return response.json();
  }

  async totpStatus() {
    const response = await fetch('/api/user/v1/totp/status', {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    });
    return response.json();
  }

  async totpRegenerateBackupCodes(password) {
    const response = await fetch('/api/user/v1/totp/regenerate_backup_codes', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password })
    });
    return response.json();
  }

  // 檢查是否已登入（基於 localStorage 中是否有用戶資料）
  isAuthenticated() {
    return !!this.getUser();
  }
}

export default new AuthService();